import React, { useEffect, useState } from "react";
import { Button, Select, Flex, useColorModeValue, Text } from "@chakra-ui/react";
import { TriangleDownIcon, TriangleUpIcon } from "@chakra-ui/icons";
import { useTranslation } from "react-i18next";


export default function OrderBySelect({ tableInstance, onChange, initialColumn, initialDirection }) {
    const { t } = useTranslation();
    const [selectedColumn, setSelectedColumn] = useState(initialColumn || "id");
    const [direction, setDirection] = useState("asc");

    useEffect(() => {
        setSelectedColumn(initialColumn);
        setDirection(initialDirection);
    }, [initialColumn, initialDirection]);

    const handleColumnChange = (e) => {
        const newCol = e.target.value;
        setSelectedColumn(newCol);
        onChange({ column: newCol, direction });
    };

    const toggleDirection = () => {
        const newDir = direction === "asc" ? "desc" : "asc";
        setDirection(newDir);
        onChange({ column: selectedColumn, direction: newDir });
    };

    return (
        <Flex align="center" gap={2} mb={4}>
            <Text fontSize="xs" w={"110px"} color={useColorModeValue("gray.500","gray.400")} fontWeight="normal">
                {t("system.labels.order-by")}
            </Text>
            <Select
                size="sm"
                variant="main"
                cursor="pointer"
                color={useColorModeValue("gray.500", "gray.400")}
                borderRadius="12px"
                value={selectedColumn}
                onChange={handleColumnChange}
            >
                <option value="">
                    {t("system.labels.order-by")}
                </option>
                {tableInstance.allColumns
                    .filter((col) => col.id !== "_selector" && col.id !== "_expander" && !col.isHidden && col.id !== "Ações" && !col.disableSortBy)
                    .map((col) => (
                        <option key={col.id} value={col.id}>
                            {col.render("Header")}
                        </option>
                    ))}
            </Select>

            <Button
                size="sm"
                onClick={toggleDirection}
            >
                {direction === "asc" ? <TriangleUpIcon /> : <TriangleDownIcon />}
            </Button>
        </Flex>
    );
}

